export const environment = {
    production: false,
    identityUrl: 'https://identity-v2.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://forms-v3.nside.io',
    apiBaseUrl: 'https://v3-api-prod.nside.io',
};
  